import { render, staticRenderFns } from "./BeneficialOwners.vue?vue&type=template&id=fc1c58ea&scoped=true&"
import script from "./BeneficialOwners.vue?vue&type=script&lang=js&"
export * from "./BeneficialOwners.vue?vue&type=script&lang=js&"
import style0 from "./BeneficialOwners.vue?vue&type=style&index=0&id=fc1c58ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1c58ea",
  null
  
)

export default component.exports